import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'
import { PAY_CENTER_PATH, CASH_WITHDRAW_MANAGEMENT_PATH } from '@/utils/micro-app'

const link: RouteRecordRaw = {
  path: PAY_CENTER_PATH,
  name: 'LeyoPayCenter',
  component: Layout,
  meta: {
    title: '实销实结自主结算',
    icon: 'financial-management|svg',
    module: 'PAY_CENTER_SETTLEMENT',
    hidePageHeader: true
  },
  children: [
    {
      path: '#/index',
      name: 'SelfSettlementManage',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        module: 'self_settlement_manage',
        title: '结算看板',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    },
    {
      path: CASH_WITHDRAW_MANAGEMENT_PATH,
      name: 'CashWithdrawManagement',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        module: 'supplier_withdraw_manage',
        title: '资金提现管理',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    },
    {
      path: '#/cash-cow-profits-view',
      name: 'CashCowProfitView',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        module: 'supplier_cash_cow_withdraw',
        title: '摇钱树利润查看',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    },
    {
      path: '#/cashcow-sales-statistics',
      name: 'CashcowSalesStatistics',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        module: 'cash_cow_sale',
        title: '摇钱树销售统计',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    },
    {
      path: '#/sales-report',
      name: 'SalesReport',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        module: 'supplier_sales_report',
        title: '销售报表',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    },
    {
      path: '#/variety-sell-statistics',
      name: 'VarietySellStatistics',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        module: 'supplier_sale',
        title: '品种销售统计',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    },
    {
      path: '#/variety-warehousing-flow',
      name: 'VarietyWarehousingFlow',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        module: 'supplier_storage',
        title: '品种入库流水',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    },
    {
      path: '#/variety-stock',
      name: 'VarietyStock',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        module: 'product_stock',
        title: '品种库存',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    },
    {
      path: '#/account_product',
      name: 'AccountProduct',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        module: 'supplier_account_product',
        title: '品种信息',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    },
    {
      path: '#/help_center',
      name: 'SettlementHelpCenter',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        module: 'help_center_supplier',
        title: '结算帮助中心',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    }
  ]
}

export default link
